import React, { useEffect, useMemo, useState } from "react";
import {
  Grid,
  MobileStepper,
  Button,
  Divider,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { useNavigate } from "react-router-dom";
import KeyboardArrowLeft from "@mui/icons-material/KeyboardArrowLeft";
import KeyboardArrowRight from "@mui/icons-material/KeyboardArrowRight";
import SwipeableViews from "react-swipeable-views";
import _ from "lodash";
import { renderTruncatedText } from "../../../core/Constant";

const isDashboardCourseInactive = (isActive) => isActive === 0;

const DashboardForumCard = ({
  heading,
  description,
  user,
  list = [],
  onButtonClick = () => { },
  date,
}) => {
  const navigate = useNavigate();
  const theme = useTheme();
  const [activeStep, setActiveStep] = useState(0);

  const displayList = useMemo(() => {
    const raw =
      Array.isArray(list) && list.length > 0
        ? list
        : list && typeof list === "object"
          ? [list]
          : [];
    return raw.filter((item) => !isDashboardCourseInactive(item?.is_active));
  }, [list]);

  const maxSteps = displayList?.length;
  const visibleSteps = Math.min(maxSteps, 5);
  const indicatorStart = Math.min(
    Math.max(activeStep - visibleSteps + 1, 0),
    maxSteps - visibleSteps
  );

  useEffect(() => {
    setActiveStep((prev) => {
      if (!displayList.length) return 0;
      return Math.min(prev, displayList.length - 1);
    });
  }, [displayList]);

  const handleNext = () => {
    setActiveStep((prevActiveStep) => prevActiveStep + 1);
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  const handleStepChange = (step) => {
    setActiveStep(step);
  };

  const onViewForum = (item) => {
    navigate("/forum-message", {
      state: { forumId: _.get(item, "id", ""), forum: item },
    });
  };

  return (
<Grid
container
flexDirection={"column"}
alignItems={"center"}
sx={{
  width: "100%",
  minWidth: 0,
  minHeight: { xs: 420, sm: 460 },
  height: "100%",
  boxSizing: "border-box",
  p: { xs: 1, sm: 2 },
}}
flexWrap={'nowrap'}
justifyContent={'center'}
>
<Grid item>
  <h3 style={{ fontWeight: 700,marginTop:15,color:"#9834F0"}}>New Threads</h3>
</Grid>

<Grid item sx={{ width: "100%", minWidth: 0, display:'flex', flexDirection:'column', flex: 1 }}>
{displayList.length === 0 ? (
      <Grid item sx={{ minHeight: 220, display: "flex", justifyContent: "center", alignItems: "center" }}>
       <p
              style={{ textAlign: "center" }}
              className="dashboard-student-heading"
            >
              No Threads Available
            </p>
      </Grid>
    ) : (
      <>
  <SwipeableViews
    axis={"x"}
    index={activeStep}
    onChangeIndex={handleStepChange}
    enableMouseEvents
    style={{
      backgroundColor: "#ffffff",
      alignItems: "center",
      justifyContent: "center",
      width: "100%",
      minWidth: 0,
      overflow: "hidden",
    }}
  >
    
    {displayList.map((item, index) => {
      return (
        <Grid
          key={item?.id ?? index}
          container
          flexDirection={"column"}
          alignItems={"center"}
        >
          <Grid item marginTop={{ xs: 1, sm: 2 }} sx={{ maxWidth: "100%", px: 1 }}>
            <p
              style={{ textAlign: "center", maxWidth: "100%", overflowWrap: "anywhere" }}
              className="dashboard-student-heading"
            >
              {renderTruncatedText(_.get(item, "name", ""),{limit : 30})}
            </p>
          </Grid>
          <Grid item sx={{ width: "100%", minWidth: 0 }}>
          {(item?.forums || []).map((val, forumIndex) => {
                      return (
                          <div key={val?.id ?? forumIndex} style={{display:'flex',flexDirection:'column',justifyContent:'center',cursor: "pointer",paddingInline:12,marginBottom:2, overflowWrap:"anywhere"}} onClick={() => onViewForum(val)}>
                             <p className="forum-card-heading-x">{val.name}</p>
                             <span className="forum-card-description-x">{val.description}</span>
    
                           <Divider variant="middle" />
                           </div>
                      )
                     })
                   }
          </Grid>
 

        </Grid>
      );
    })}
  </SwipeableViews>
          <Grid item sx={{ width: "100%" }}>
            <MobileStepper
              steps={visibleSteps}
              position="static"
              activeStep={activeStep - indicatorStart}
              nextButton={
                <Button
                  size="small"
                  onClick={handleNext}
                  disabled={activeStep === maxSteps - 1}
                  sx={{
                    "&:hover": {
                      backgroundColor: "#ffffff !important",
                      color: "#28b882 !important",
                      boxShadow: "10px !important",
                    },
                  }}
                >
                  {/* Next */}
                  {theme.direction === "rtl" ? (
                    <KeyboardArrowLeft />
                  ) : (
                    <KeyboardArrowRight />
                  )}
                </Button>
              }
              backButton={
                <Button
                  sx={{
                    "&:hover": {
                      backgroundColor: "#ffffff !important",
                      color: "#28b882 !important",
                      boxShadow: "10px !important",
                    },
                  }}
                  size="small"
                  onClick={handleBack}
                  disabled={activeStep === 0}
                >
                  {theme.direction === "rtl" ? (
                    <KeyboardArrowRight />
                  ) : (
                    <KeyboardArrowLeft />
                  )}
                  {/* Back */}
                </Button>
              }
            />
          </Grid>
        </>
    )
  }
</Grid>
</Grid>
  );
};

export default DashboardForumCard;
